export const ALLOGGIATI_STATUS = {
    ready: "ready",
    scheduled: "scheduled",
    running: "running",
    completed: "completed",
    failed: "failed"
}

export const ABIT_STATUS = {
    pending: "pending",
    completed: "completed",
    failed: "failed"
}

export const DOCUMENTS_TYPES = [
    {
        value: 'identity_card',
        label: `Carta d'identità`,
    },
    {
        value: 'passport',
        label: `Passaporto`,
    },
    {
        value: 'driving_license',
        label: 'Patente di guida',
    }
]

export const PAYMENTS_TYPES = [
    {
        value: 'cash',
        label: 'Contanti',
    },
    {
        value: 'check',
        label: 'Assegno',
    },
    {
        value: 'wire_transfer',
        label: 'Bonifico bancario',
    },
    {
        value: 'debit_card',
        label: 'Carta di debito',
    },
    {
        value: 'credit_card',
        label: 'Carta di credito',
    },
    {
        value: 'other',
        label: 'Altro',
    },
]

export const PAYMENTS_REASONS = [
    {
        value: 'deposit',
        label: 'Pagamento caparra',
        transactionType: 'incoming',
    },
    {
        value: 'down_payment',
        label: 'Acconto',
        transactionType: 'incoming',
    },
    {
        value: 'balance',
        label: 'Saldo',
        transactionType: 'incoming',
    },
    {
        value: 'refund',
        label: 'Rimborso',
        transactionType: 'outgoing',
    }
]